import { query } from '@confluence/query-preloader-tools';

import { TemplatesCollectionEligibleQuery } from './TemplatesCollectionEligibleQuery.graphql';

export const preloadTemplatesCollectionEligible = () =>
	query({
		query: TemplatesCollectionEligibleQuery,
	});
